import { manifests as repositoryManifests } from './repository/manifests.js';

export const manifests = [...repositoryManifests];
